import classNames from 'classnames';
import { useStoreState } from 'easy-peasy';
import { PropTypes } from 'prop-types';
import React, { useRef } from 'react';

import { StackMenu } from '@ge/feat-manage/components/planning/month/cards/stack-card-menu';
import {
  BundledCountBadge,
  TaskCard,
  TaskCardEntity,
  TaskCardInfo,
  MultiScheduleCountBadge,
} from '@ge/feat-manage/components/planning/shared';
import { DragItemTypes } from '@ge/feat-manage/context';
import { usePlanningContext } from '@ge/feat-manage/context/planning-context';
import { useCalendarCardMenu } from '@ge/feat-manage/data-hooks/use-calendar-card-menu';
import { getActiveDelays, getMultiDaySchedule } from '@ge/feat-manage/util/tasks-util';
export const DayCardSingle = ({
  task,
  top,
  position,
  width,
  draggable,
  onDrop,
  laneIndex,
  secondaryIndex,
  itemIndex,
  onClick,
  bundlePresent,
  partialCompleted,
  sameAssetTaskCount,
  tasks,
  bundleCount,
  date,
  laneCrew
}) => {
  const {
    planningState: { handleDragStart, handleDragEnd, range },
  } = usePlanningContext();

  const menuRef = useRef(null);
  const anchorEl = useRef(null);
  const { delayCodeFlag } = useStoreState((state) => state.tenant.featureFlags);

  const { menuTaskId, menuShown, destroyStackMenu, showStackMenu } = useCalendarCardMenu();

  const isDelayActive =
    (getActiveDelays(tasks) || (task.bundledTasksList && getActiveDelays(task.bundledTasksList))) &&
    delayCodeFlag;

  const isMultidaySchedule =
    getMultiDaySchedule(tasks) ||
    (task.bundledTasksList && getMultiDaySchedule(task.bundledTasksList));

  return (
    <TaskCard
      top={top}
      position={position}
      width={width}
      className={classNames(
        `${partialCompleted ? 'partial' : task.status}`,
        'lasso-card',
        {
          draggable,
        },
        range.type,
      )}
      draggable={draggable && !isMultidaySchedule}
      onMouseEnter={() => showStackMenu(task.id)}
      onMouseLeave={destroyStackMenu}
      ref={anchorEl}
      onDragStart={() => {
        destroyStackMenu();
        handleDragStart(
          task,
          DragItemTypes.CARD,
          null,
          secondaryIndex !== null ? `${laneIndex}-${secondaryIndex}` : laneIndex,
        );
      }}
      onDragEnd={handleDragEnd}
      onDrop={onDrop}
      data-laneindex={laneIndex}
      data-id={task.id}
      data-id3={task.id}
      data-secondaryindex={secondaryIndex}
      data-dayindex={itemIndex}
      onClick={(e) => onClick(e)}
      isDelayActive={isDelayActive}
      isMultidaySchedule={isMultidaySchedule}
    >
      <StackMenu
        open={menuShown && menuTaskId == task.id}
        tasks={tasks}
        onClose={destroyStackMenu}
        ref={menuRef}
        anchorEl={anchorEl && anchorEl.current}
        bundlePresent={bundlePresent}
        date={date}
        isDelayActive={isDelayActive}
        isMultidaySchedule={isMultidaySchedule}
        laneCrew={laneCrew}
      />
      <TaskCardEntity className="asset-name" task={task} isDelayActive={isDelayActive} />
      <TaskCardInfo task={task} sameAssetTaskCount={sameAssetTaskCount} />
      <MultiScheduleCountBadge
        bundlePresent={bundlePresent}
        isMultidaySchedule={isMultidaySchedule}
      />
      <BundledCountBadge
        className={range.type}
        bundlePresent={bundlePresent}
        bundleCount={bundleCount}
        isMultidaySchedule={isMultidaySchedule}
      />
    </TaskCard>
  );
};

DayCardSingle.propTypes = {
  task: PropTypes.instanceOf(Array),
  tasks: PropTypes.instanceOf(Array),
  top: PropTypes.number,
  position: PropTypes.number,
  width: PropTypes.number,
  laneIndex: PropTypes.number.isRequired,
  secondaryIndex: PropTypes.number,
  itemIndex: PropTypes.number.isRequired,
  onDrop: PropTypes.func,
  onClick: PropTypes.func,
  draggable: PropTypes.bool,
  bundlePresent: PropTypes.bool,
  multidaySchedulePresent: PropTypes.bool,
  partialCompleted: PropTypes.bool,
  sameAssetTaskCount: PropTypes.number,
  bundleCount: PropTypes.number,
  date: PropTypes.instanceOf(Object), // dayjs
  laneCrew: PropTypes.any,
};

DayCardSingle.defaultProps = {
  top: null,
  position: null,
  width: null,
  onDrop: () => {},
  onClick: () => {},
  secondaryIndex: null,
  draggable: false,
  bundlePresent: false,
  partialCompleted: false,
  sameAssetTaskCount: 0,
  bundleCount: 0,
  multidaySchedulePresent: false,
  laneCrew: {},
};
